var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-button',{attrs:{"icon":"icon-chevron-left"},on:{"click":function($event){return _vm.$emit('back')}}},[_vm._v(_vm._s(_vm.name))])
}
var staticRenderFns = []

export { render, staticRenderFns }